import React from 'react'
import { compose, withState } from 'recompose'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import muiThemeable from 'material-ui/styles/muiThemeable'

const Icon = styled.i`
  margin-left: 5px;
  :hover {
    cursor: pointer;
  }
`

const HoverBar = compose(
  withState('isMouseEnter', 'setIsMouseEnter', false),
  muiThemeable(),
)(
  ({
    className,
    isMouseEnter,
    setIsMouseEnter,
    muiTheme: {
      palette: {
        accent1Color,
      }
    },
    icons,
    children,
  }) => {
    return (
      <div
        className={`hover-bar ${className}`}
        style={{
          zIndex: 1001,
          position: 'relative',
          borderWidth: 1,
          borderStyle: 'solid',
          borderColor: isMouseEnter ? accent1Color : 'transparent',
        }}
        onMouseEnter={() => setIsMouseEnter(true)}
        onMouseLeave={() => setIsMouseEnter(false)}
      >
        {isMouseEnter &&
          <span
            style={{
              top: 0,
              left: 0,
              display: isMouseEnter ? 'block' : 'none',
              position: 'absolute',
              zIndex: 1,
              backgroundColor: accent1Color,
              color: '#ffffff',
              fontSize: 10,
              padding: '0 5px',
              opacity: 0.5,
            }}
          >
            {icons.map(({
              icon,
              onClick,
            }, i) => (
              <Icon
                key={i}
                className={icon}
                onClick={(e) => {
                  e.stopPropagation()
                  onClick()
                }}
              />
            ))}
          </span>
        }
        {children}
      </div>
    )
  }
)

HoverBar.propTypes = {}
HoverBar.defaultProps = {}

export default HoverBar



// WEBPACK FOOTER //
// ./src/components/hover/HoverBar.js